var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-badge"},[_vm._t("default"),(_vm.isDot)?_c('div',{staticClass:"m-badge__dot",style:(_vm.bgStyle)}):(_vm.value)?_c('div',{class:[{ 'is-static': _vm.isStatic }, 'm-badge__count'],style:(_vm.bgStyle)},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }